/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LockIcon/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Tysiav2LockIcon from 'DesignSystem/Svgs/Tysiav2LockIcon/index'



/** @type {import('Simple/types.js').View} */
export default function LockIcon({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Payors/Payor/InstallmentAmount/LockAction/Icon/LockIcon"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<Tysiav2LockIcon
  viewPath={`${viewPath}/Tysiav2LockIcon`}
 fill2={dtColorsNeutral500}
 height={dtSpaceL}
 width={dtSpaceL}
/>
{children}
</React.Fragment>)
}